[
    {
        "policyNumber": "7600221906",
        "uqPolicyId": 1054066399,
        "policyId": 1034437729,
        "claimId": 904383959,
        "claimNumber": "2120014594",
        "eventDate": "2021-08-06T00:00:00.000+02:00",
        "registerDate": "2021-08-06T08:48:08.000+02:00",
        "reportDate": "2021-08-06T00:00:00.000+02:00",
        "closeDate": null,
        "status": "Znovuotvoren\u00fd",
        "paymentAmountSum": 0,
        "noPaymCloseFlg": null,
        "lobId": 9,
        "lob": "PP",
        "detailTypeIdentifier": "HOME-INSURANCE",
        "claimSubj": "Stromov\u00e1 5, 05801 Poprad",
        "liability": 0,
        "claimClassId": 78,
        "claimClassLabel": "PP-Rozbitie skla",
        "claimTrackLink": null
    },
    {
        "policyNumber": "7600257177",
        "uqPolicyId": 1054066399,
        "policyId": 1034437729,
        "claimId": 904383961,
        "claimNumber": "2120014596",
        "eventDate": "2021-08-06T00:00:00.000+02:00",
        "registerDate": "2021-08-06T08:55:05.000+02:00",
        "reportDate": "2021-08-06T00:00:00.000+02:00",
        "closeDate": null,
        "status": "Otvoren\u00fd",
        "paymentAmountSum": 0,
        "noPaymCloseFlg": null,
        "lobId": 9,
        "lob": "PP",
        "detailTypeIdentifier": "HOME-INSURANCE",
        "claimSubj": "Stromov\u00e1 5, 05801 Poprad",
        "liability": 0,
        "claimClassId": 82,
        "claimClassLabel": "PP-Zate\u010denie z vodovodu\/kanaliz\u00e1cie",
        "claimTrackLink": null
    },
    {
        "policyNumber": "7600257177",
        "uqPolicyId": 1054066399,
        "policyId": 1034437729,
        "claimId": 904388953,
        "claimNumber": "2120014601",
        "eventDate": "2021-08-09T00:00:00.000+02:00",
        "registerDate": "2021-08-09T15:02:58.000+02:00",
        "reportDate": "2021-08-09T00:00:00.000+02:00",
        "closeDate": null,
        "status": "Otvoren\u00fd",
        "paymentAmountSum": 0,
        "noPaymCloseFlg": null,
        "lobId": 9,
        "lob": "PP",
        "detailTypeIdentifier": "HOME-INSURANCE",
        "claimSubj": "Stromov\u00e1 5, 05801 Poprad",
        "liability": 0,
        "claimClassId": 82,
        "claimClassLabel": "PP-Zate\u010denie z vodovodu\/kanaliz\u00e1cie",
        "claimTrackLink": "https:\/\/ct4-test.allianzsp.sk\/sk\/71b0120a"
    },
    {
        "policyNumber": "7600257177",
        "uqPolicyId": 1054066399,
        "policyId": 1034437729,
        "claimId": 904391953,
        "claimNumber": "2120014603",
        "eventDate": "2021-08-10T00:00:00.000+02:00",
        "registerDate": "2021-08-10T07:30:17.000+02:00",
        "reportDate": "2021-08-10T00:00:00.000+02:00",
        "closeDate": null,
        "status": "Otvoren\u00fd",
        "paymentAmountSum": 0,
        "noPaymCloseFlg": null,
        "lobId": 9,
        "lob": "PP",
        "detailTypeIdentifier": "HOME-INSURANCE",
        "claimSubj": "Stromov\u00e1 5, 05801 Poprad",
        "liability": 0,
        "claimClassId": 82,
        "claimClassLabel": "PP-Zate\u010denie z vodovodu\/kanaliz\u00e1cie",
        "claimTrackLink": "https:\/\/ct4-test.allianzsp.sk\/sk\/73eb5b71"
    }
]